var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonEjHanterad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.932,
    height: 17.247,
    viewBox: "0 0 11.932 17.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EJ_hanterad",
    "data-name": "EJ hanterad",
    transform: "translate(-8129.501 -5806.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36659",
    "data-name": "Path 36659",
    d: "M136.082,22.436l-5.661-4.083a.75.75,0,1,1,.878-1.217l4.783,3.45,4.771-3.442a.75.75,0,1,1,.878,1.217Z",
    transform: "translate(7999.391 5801.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3705",
    "data-name": "Line 3705",
    d: "M0,15.427a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V14.677A.75.75,0,0,1,0,15.427Z",
    transform: "translate(8135.467 5807.653)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonEjHanterad);
export default __webpack_public_path__ + "static/media/Ikon_Ej_hanterad.11fac21179aca27fc390f8ce21799bd0.svg";
export { ForwardRef as ReactComponent };